import { Injectable } from '@angular/core';
import { WebSocketClient } from '../utils/api/websocket-utils';
import { Subject, Observable } from 'rxjs';
import { map,filter } from 'rxjs/operators';

export type IncomingMessage = {
  type: string;
  data: any;
};

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private ws!: WebSocketClient;
  private messageSubject = new Subject<IncomingMessage>();

  // Observable stream for consumers
  public messages$: Observable<IncomingMessage> = this.messageSubject.asObservable();

  public async startSubscription() {
    console.log('🔔 Starting notification subscription');
    try {
      if (this.ws) {
        console.log('🔌 Disconnecting existing WebSocket connection');
        this.ws.disconnect();
      }
    } catch (err) {
      console.warn('Error disconnecting WebSocket:', err);
    }

    this.ws = new WebSocketClient('wss://capella.api.weapps.net');
    // const ws = new WebSocketClient('wss://43t42lon7k.execute-api.us-east-1.amazonaws.com/prod')

    await this.ws.connect();

    this.ws.onMessage((msg: any) => {
      console.log('💬 Received message', msg);
      if (msg?.type && msg?.data) {
        this.messageSubject.next(msg as IncomingMessage);
      }
    });
  }

  public stopSubscription(){
    try{
      if(this.ws){
        console.log('🔌 Stopping notification subscription');
        this.ws.disconnect();
        this.ws = undefined as any; // Clear the reference
      }
    } catch (err) {
      console.warn('Error stopping WebSocket subscription:', err);
    }
  }

  // Utility to filter by message type
public on<T = any>(type: string): Observable<T> {
  return this.messages$.pipe(
    filter((msg): msg is IncomingMessage & { data: T } => msg.type === type),
    map(msg => msg.data) // ✅ Only return the data, as type T
  );
}
}

/**
 this.notificationService.on<MyDataType>('chatMessage').subscribe(msg => {
  console.log('Chat Message:', msg.data);
});

this.notificationService.messages$.subscribe(msg => {
  console.log('Received any message:', msg);
});
 */